import { LocaleType } from '../../constants/localeConstants';
import { LocaleMapping } from '../../types';
import { getValidLocale } from './getValidLocale';

export const getResolvedLocale = (locale?: LocaleType | Partial<LocaleMapping>): LocaleMapping => {
  const inputLocale = typeof locale === 'object' ? locale?.input : locale;
  const outputLocale = typeof locale === 'object' ? locale?.output : locale;
  const validInputLocale = getValidLocale(inputLocale);
  const validOutputLocale = getValidLocale(outputLocale);
  return {
    input: validInputLocale,
    output: validOutputLocale,
  };
};
